import styled from "styled-components";
import { ScrollContainer } from "../../style/LogStyles";

/** Positioning context for the loading pill, so it floats over the posts without scrolling with them. */
export const TimelineFrame = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
`;

/** Newest post at the bottom, where the list starts. */
export const TimelineScroller = styled(ScrollContainer)`
  display: flex;
  flex-direction: column-reverse;
  flex: 1 1 0;
  min-height: 0;
  height: auto;
`;

export const LoadingPill = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  /* Over the sticky date pills (1); under the status overlay (900), drawer (1000+) and image viewer (10000+). */
  z-index: 3;
  pointer-events: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 16px;
  background: rgba(34, 37, 41, 0.92);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
`;
